import React from "react";
import Image from "next/image";
import Link from "next/link";
import { format } from "date-fns";


const JobCard = ({
  title,
  companyName,
  companyAddress,
  minSalaryOffer,
  maxSalaryOffer,
  routes_id,
  jobType,
  noOpening,
  endFiling,
  branchName,
  imgURL
}) => {
  return (
    <div className="grid grid-cols-10 gap-5 items-center bg-gray-100 rounded-xl p-8 mb-6">
      <div className="lg:col-span-2 md:col-span-3 col-span-10 text-center">
        <Image
          className="object-cover !w-full rounded-md"
          src={imgURL ? imgURL :"/assets/img/img1.jpg"}
          alt="Job Illustration"
          width={150}
          height={120}
        />
      </div>
      <div className="lg:col-span-6 md:col-span-7 col-span-10">
        <h2 className="text-blue text-lg mb-3"></h2>
        <div className="grid sm:grid-cols-3 grid-cols-2 items-start mb-2">
          <div className="col-span-1">
            <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-0">Branch:</p>
          </div>
          <div className="sm:col-span-2 col-span-1">
            <p className="text-gray-800 text-sm mb-0">{branchName}</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-3 grid-cols-2 items-start mb-2">
          <div className="col-span-1">
            <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-0">Job Type:</p>
          </div>
          <div className="sm:col-span-2 col-span-1">
            <p className="text-gray-800 text-sm mb-0">{jobType}</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-3 grid-cols-2 items-start mb-2">
          <div className="col-span-1">
            <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-0">No. of openings:</p>
          </div>
          <div className="sm:col-span-2 col-span-1">
            <p className="text-gray-800 text-sm mb-0">{noOpening}</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-3 grid-cols-2 items-start mb-2">
          <div className="col-span-1">
            <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider mb-0">End of filing:</p>
          </div>
          <div className="sm:col-span-2 col-span-1">
            <p className="text-gray-800 text-sm mb-0">{format(new Date(endFiling),"PP")}</p>
          </div>
        </div>
      </div>
      <div className="lg:col-span-2 col-span-10">
        <div className="text-center">
          <Link href={`/careers/${routes_id}`}>
            <a className="btn-secondary rounded-full text-xs hover:text-white">View Details</a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
